import { Container } from "@brightagency/headstart-common";
import React, { useEffect, useState } from "react";
import { useSuburbName } from "../../../utils";
import { useSortingCoords } from "../../../utils/hooks";
import { ListingCard } from "../../molecules/ListingCard";
import { SkeletonCard } from "../../molecules/SkeletonCard";
import { useCardCarousel } from "../Carousel/controller";
import { useDirectoryQuery } from "../HeroDirectory";
import { Skeleton } from "../RelatedLocalServices/Skeleton";
import { InfoBar } from "./InfoBar";
import { useDirectorySearch } from "./services";
import { Outer, Inner, Listings } from "./styled";

export enum ViewModes {
    List,
    Grid,
}

export const DirectoryContent: React.FC = () => {
    const [viewMode, setViewMode] = useState<ViewModes>(ViewModes.Grid);
    const query = useDirectoryQuery();
    const sortingCoords = useSortingCoords();
    const { listings, error, loading, loadMore, loadResults } = useDirectorySearch();
    const { Carousel, scrollLeft, scrollRight, canScroll } = useCardCarousel(listings.length);
    const suburbName = useSuburbName();

    useEffect(() => {
        loadResults(query, sortingCoords);
    }, [query, sortingCoords, loadResults]);

    // Error
    if (error) {
        return (
            <Outer>
                <Inner>
                    <p>Something went wrong, please try again.</p>
                </Inner>
            </Outer>
        );
    }

    const safeListings = listings ?? [];

    return (
        <Outer>
            <Inner>
                <Container>
                    <InfoBar
                        listingCount={
                            <h3>Services near {suburbName}</h3>
                        }
                        viewMode={viewMode}
                        onViewModeChange={setViewMode}
                        onLeftClick={scrollLeft}
                        onRightClick={scrollRight}
                        canScroll={canScroll || loading}
                    />
                </Container>
                <Listings>
                    <div className={safeListings.length <= 0 && !loading ? 'listing-not-found' : ''}>
                    {viewMode === ViewModes.Grid && (
                        <Carousel onScrolledToEnd={loadMore}>
                            {loading && safeListings.length === 0 ?
                                Array(3)
                                    .fill(1)
                                    .map((el, index) => <SkeletonCard key={index} />)
                                : safeListings.length > 0
                                    ? safeListings.map(listing => (
                                        <ListingCard key={listing.id} listing={listing} compact={false} />
                                    ))
                                    : <Skeleton />
                            }
                            {safeListings.length > 0 && loading ? <SkeletonCard /> : null}
                        </Carousel>
                    )}
                    </div>
                </Listings>

            </Inner>
        </Outer>
    );
};
